Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Any = exports.anyPreset = void 0;

var core_1 = require("@emotion/core");

var styled_system_1 = require("@wheelroom/styled-system");

var merge_ncss_1 = require("../lib/merge-ncss");

var element_1 = require("./element");

var any_reset_1 = require("./any-reset");

exports.anyPreset = {
  ncss: {
    boxSizing: 'border-box'
  }
};

var getAttrs = function getAttrs(props) {
  var attrs = Object.assign(Object.assign({}, element_1.getElementAttrs(props)), {
    'aria-modal': props.ariaModal,
    role: props.role,
    onClick: props.onClick,
    dangerouslySetInnerHTML: props.dangerouslySetInnerHTML
  });
  return attrs;
};

var getPolyPreset = function getPolyPreset(props) {
  var resetMap = any_reset_1.anyResetMap;
  var polyPreset = {
    ncss: {}
  };

  if (props.polyPreset && props.is && Object.keys(resetMap).includes(props.is)) {
    polyPreset = merge_ncss_1.mergeNcss([resetMap[props.is], props.wheel.elementNcss[props.is]]);
  }

  return polyPreset;
};

exports.Any = function (props) {
  var label = {
    ncss: {
      label: "any-is-".concat(props.is)
    }
  };
  var attrs = getAttrs(props);
  var polyPreset = getPolyPreset(props);
  attrs.css = styled_system_1.styledSystem(props.wheel.wrSystemConfig, props.wheel.wrSystemTheme, merge_ncss_1.mergeNcss([label, exports.anyPreset, props.wheel.elementNcss.any, polyPreset, props.wheel.style, props]));
  return core_1.jsx(props.is || 'div', attrs, props.children);
};